<template>
  <div>
    <MainForm
      :name="FORM_NAMES.technicalError"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      :ui-form="uiForm"
      :ui-title="``"
    >
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.appointment"
        ui-subtitle="We just need some more information from you to update you on your application."
        ui-error-message="Please review the fields marked in red"
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.homeAddress"
          :ui-title="titleHome"
        >
          <UiWrapper :name="FIELD_NAMES.homeAddress">
            <Choice
              :options="[
                {
                  value: 'HOME',
                  label: 'Residential Address'
                }
              ]"
            />
          </UiWrapper>
        </FieldsetModel>

        <!-- Home -->

        <FieldsetModel :ui="uiBaseFieldset" name="fieldSetHome" ui-columns="2">
          <UiWrapper
            :name="FIELD_NAMES.addressLine1Home"
            label="Address Line 1"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.addressLine2Home"
            label="Address Line 2"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.residentialEmirateHome" label="Emirate" optional>
            <Dropdown
              placeholder="Emirate"
              v-bind:selected="`selected`"
              :options="EMIRATE_LIST_CARD"
            />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.homeCountryCountryHome" label="Country" optional>
            <Suggest
              :exact-match="true"
              placeholder="Country"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCountriesAppointment"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.poBoxHome"
            label="PO Box"
            optional
            :validations="pinCodeValidations"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.localReference"
          ui-title="Please provide us with one local reference contact details(It could be your friend/colleague)"
        >
          <UiWrapper
            :name="FIELD_NAMES.fullNameRefernce"
            label="Name"
            :validations="[
              {
                errorMessage: 'Field contains invalid characters',
                condition: patternCondition(NAMES_CHARS),
                name: 'lastname-chars'
              }
            ]"
          >
            <InputText />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.referencePhoneNumber"
            label="Mobile Number"
            :validations="validations"
          >
            <InputText type="tel" :prefix="prefix" :maxlength="maxlength" />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          ui-title="Please provide your home country reference contact details (family member/relative only)"
          :name="FIELDSET_NAMES.homeCountryReference"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.fullNameHomecountry"
            label="Name"
            :validations="[
              {
                errorMessage: 'Field contains invalid characters',
                condition: patternCondition(NAMES_CHARS),
                name: 'lastname-chars'
              }
            ]"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.homeCountryPhoneCountryCode" label="Country code">
            <Dropdown placeholder="Country code" :options="MAPPED_PHONE_CODE" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryPhone"
            label="Mobile Number"
            :validations="validationsGlobal"
          >
            <InputText type="tel" :minlength="minlength" :maxlength="minlengthGlobal" />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          ui-title="Please provide your home country address"
          name="homeCountryAddress"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.homeCountryAddress"
            label="Address Line 1"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryAdditionalAddress"
            label="Address Line 2"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>

          <UiWrapper :name="FIELD_NAMES.homeCountryCountry" label="Country" optional>
            <Suggest
              :exact-match="true"
              placeholder="Country"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCountries"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.homeCountryPoscode"
            label="PO Box"
            optional
            :validations="pinCodeValidations"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>
    </MainForm>
  </div>
</template>

<script>
// Models
var flag = true;
let newProduct = "";
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";

// Utils
import * as conditions from "@/forms/conditions";
import { patternCondition } from "@/forms/conditions";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import store from "@/store";
import FIELD_NAMES from "@/forms/constants/field-names";
import FIELDSET_NAMES from "@/forms/constants/fieldset-names";
import FieldsetModel from "@/lib/components/models/fieldset";
import UiWrapper from "@/forms/components/base/ui-wrapper";
import Appointment from "@/forms/components/shared/fieldsets/appointment-date";

import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
import {
  MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  MOBILE_NUMBER_LENGTH_GLOBAL,
  DIGIT_CHARS,
  NAMES_CHARS,
  MAPPED_PHONE_CODE,
  ADDRESS_CHARS
} from "@/forms/constants/onboarding-logic";
import FieldsetAppointmentDate from "@/forms/components/shared/fieldsets/appointment-date";
import {
  InputText,
  InputSlide,
  Dropdown,
  PlainText,
  Choice,
  Feedback,
  InputTime,
  Suggest
} from "@dunia/ui";
export default {
  name: "TechnicalError",

  mixins: [FormComponentMixin],

  components: {
    // Components

    MainForm,
    StepModel,
    Appointment,
    InputText,
    Dropdown,
    Suggest,
    FieldsetModel,
    UiWrapper,
    Choice,
    FieldsetMobilePhone,
    FieldsetFullName,
    FieldsetAppointmentDate
  },
  props: {
    name: {
      type: String,
      default: FIELDSET_NAMES.appointmentSetAddress
    },
    title: {
      type: String,
      default: "Please enter your office address below"
    },
    titleHome: {
      type: String,
      default: "Please enter your UAE residential address below"
    },
    validations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits"
        },
        {
          errorMessage: "Your phone must start with a 5",
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: "check-is-mobile-starting-number"
        },
        {
          errorMessage: "Your phone must have 9 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: "check-is-mobile-length"
        }
      ]
    },
    validationsGlobal: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits"
        },

        {
          errorMessage: "Your phone must be between 9-11 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH_GLOBAL),
          name: "check-is-mobile-length"
        }
      ]
    },
    addressValidations: {
      type: Array,
      default: () => [
        {
          errorMessage:
            "Field contains invalid characters. Albhabets, Numbers and special character (- , / space) are allowed.",
          condition: patternCondition(ADDRESS_CHARS),
          name: "address-chars"
        }
      ]
    },
    pinCodeValidations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Field contains invalid characters.",
          condition: patternCondition(DIGIT_CHARS),
          name: "pincode-chars"
        }
      ]
    },
    prefix: {
      type: String,
      default: "+971"
    },
    maxlength: {
      type: Number,
      default: 9
    },
    minlength: {
      type: Number,
      default: 9
    },
    minlengthGlobal: {
      type: Number,
      default: 11
    }
  },
  methods: {
    ...conditions,
    finishCallback() {
      let product = this.$store.state.productType;

      if (product === "Personal_Loan") {
        newProduct = "Loan";
      } else if (product === "Credit Card") {
        newProduct = "Credit Card";
      }
      let status = this.$store.state.appianIncomeInfo;
      let cifNumber;
      if (this.$store.state.cifnumber) {
        cifNumber = this.$store.state.cifnumber;
      } else {
        cifNumber = "";
      }

      let message;
      if (this.$store.state.employeeCodes) {
        message = `TECHNICAL ERROR! Thanks ${this.userName}! Your customer identification number is ${cifNumber}. 
    Our team will contact you shortly to update you on your application.`;
      } else {
        message = `Dear ${this.userName}, thank you for your application. Our team will contact you shortly to update you on your Deem Auto Loan application.`;
      }

      this.showEndPage({
        subtitle: message,
        actionNameEndForm: "Back To Home"
      });
    }
  },

  mounted() {}
};
</script>
